import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { MobileSidebar } from "./MobileSidebar";
import { useMobileNav } from "@/hooks/useMobileNav";
import { cn } from "@/lib/utils";

export function AdminLayout() {
  const { isMobile, isNavOpen, toggleNav, closeNav } = useMobileNav();

  return (
    <div className="min-h-screen bg-background">
      <Header onMenuClick={toggleNav} isMobile={isMobile} />

      {/* Desktop Sidebar - hidden on mobile */}
      {!isMobile && <Sidebar />}

      {/* Mobile Sidebar (Sheet) */}
      {isMobile && (
        <MobileSidebar isOpen={isNavOpen} onClose={closeNav} />
      )}

      <main
        className={cn(
          "pt-14 transition-all",
          isMobile ? "pl-0 px-3 sm:px-4" : "pl-56"
        )}
      >
        <div className="container p-4 md:p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default AdminLayout;
